/**
 * Recursively replace undefined values with null
 */
export default function nullifyEmptyValues<T extends Record<string, unknown>>(
  values: T
) {
  return JSON.parse(JSON.stringify(values, (_key, value) => value ?? null));
}
